import { useQuery } from "@tanstack/react-query"
import { shopifyProductTagsQuery } from "modules/settings/lib/shopify/shopifyProductTagsQuery"

export const useShopifyProductTagsQuery = (enabled: boolean) =>
  useQuery({ ...shopifyProductTagsQuery(), enabled })
